function checkValidPassword(pw) {
  const ret = {}
  const allowedReg = /^[a-zA-Z0-9-_!@#\$%^&\*\(\)+=~`\{\}\[\]'":;\/?,.<>]{8,}$/

  if (!pw.match(allowedReg)) {
    ret.password_invalid = true
  }

  return ret
}

export default {
  methods: {
    checkValidPassword,
  }
}
